<template>
	<div class="simple-multiplication-component">
		<div class="simple-multiplication-container">
			<div class="simple-multiplication-wrapper">
				<div v-if="(fact[0].length < 2 && fact[1].length < 2) || fact.includes(1)">
					{{ read_notation(operands[1]) + 'x' + read_notation(operands[0]) }} = {{ read_notation(result) }}
				</div>
				<div v-else class="">
					<div class="bloc-operation">
						<div class="operator"> x </div>
						<div class="operands">
							<div v-for="(operand, i) in operands" :class="[`operand fact-${i + 1}`]">
								{{ read_notation(operand) }}
							</div>
						</div>
					</div>
					<hr class="line">
					<template v-if="stepsResult.length > 1">
						<div class="bloc-operation">
							<div class="operator"> + </div>
							<div class="operands steps-result">
								<transition-group tag="div" class="steps-multiplication">
									<div v-for="(item, i) in stepsResult" class="step-multiplication" :key="hash(item + ' - ' + i)">
										<div>{{ item }}</div>
									</div>
								</transition-group>
							</div>
						</div>
						<hr class="line" />
					</template>
					<div class="result">{{read_notation(result)}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	const $operations = require("../scripts/variables").operations;
	import BaseExerciseMixin from '../../js/BaseExerciseMixin';
	export default {
		name: 'SimpleMultiplication',
		mixins: [BaseExerciseMixin],
		props: {
			fact: { type: Array, required: true },
		},
		data(){
			return {
				result: $operations.unknow(this.operator, this.fact),
				operands: this.fact.filter(Number).sort((a, b) => Number(b).getLength() - Number(a).getLength()),
				isFloat: this.fact.map(el => parseInt(el) != Number(el)).reduce((a, b) => a || b),
				stepsResult: [],
			}
		},
		created(){
			let stepsResult = [], fact1 = Number(this.operands[0]), fact2 = Number(this.operands[1]), k = 0, p = 1,
				fact2_tab = fact2.toString().split('.').join('').split(''), fact1_tab = Number(fact1.toString().split('.').join('')), l = fact2_tab.length;
			for(let i = fact2_tab.length; i > 0; i--){
				let res = fact1_tab * fact2_tab[l - k - 1] * p;
				if(res != 0){
				}else{
					res = res.toString().split('');
					for(let j = 0; j < fact1.getLength(); j++){
						res.push("0");
					}
				}
				k++;
				stepsResult.push(this.read_notation(res));
				p *= 10;
			}
			let result = fact1 * fact2
			if(this.isFloat){
				let dec = this.operands.map(el => Number(el).D_P().length).reduce((a, b) => a + b, 0);
				result = result.toFixed(dec);
			}
			this.result = result;
			this.stepsResult = stepsResult;
		},
		method:{

		}
	};
</script>

<style type="text/css" lang="scss">
	.simple-multiplication-component{
		.simple-multiplication-container {
			text-align: center;
			.simple-multiplication-wrapper {
				display: inline-block;
				margin-top: 2rem;
				.bloc-operation {
					display: flex;
					align-items: flex-end;
					.operator {
						margin-top: 0rem;
						margin-bottom: 0rem;
						margin-right: 0 !important;
						padding-right: 0.5rem;
						padding-left: 0.5rem;
					}
					.operands {
						flex-grow: 1;
						div {
							text-align: right;
						}
						.fact2 {
							margin-top: 0 !important;
						}
						.operand {
							line-height: 1.1;
						}

						&.steps-result {
							.steps-multiplication {
								.step-multiplication {
									line-height: 1.1;
									&:not(:first-child) {
										color: #99c;
									}
								}
							}
						}
					}
				}
				.line {
					border-bottom: 1px solid black;
					margin: 0;
			// margin-top: -0.4rem !important;
		}
		.result{
			text-align: right;
		}
			}
		}
	}
</style>